// extracted by mini-css-extract-plugin
module.exports = {"container":"orderSummarySection_container__2tZL1"};